import { Box, Button, Typography } from "@mui/material"
import type { SxProps, Theme } from "@mui/material"

const CONTAINER_SX = { px: 2, py: 3 } satisfies SxProps<Theme>
const RETRY_SX = { mt: 1 } satisfies SxProps<Theme>

interface PatStatePanelProps {
  isError: boolean
  onRetry: () => void
}

// The card is hidden entirely while its query is pending (see index.tsx), so a loading
// state can never render here — this panel is error-or-nothing.
export default function PatStatePanel({ isError, onRetry }: PatStatePanelProps) {
  if (isError) {
    return <Box sx={CONTAINER_SX}>
      <Typography variant="body2" color="error">Unable to load your personal access tokens.</Typography>
      <Button variant="contained" size="small" onClick={onRetry} sx={RETRY_SX}>Retry</Button>
    </Box>
  }

  return null
}
